<div [formGroup]="form" class="grid-form form-container">
  <mat-card-content class="content">
    <div class="grid-container">
      <div data-row-span="8">
        <ng-container *ngFor="let column of columns">
          <div *ngIf="column.span === 4" data-field-span="4">
            <strong>{{ column.name }}</strong>
          </div>
          <div *ngIf="column.span === 2" data-field-span="2">
            <strong>{{ column.name }}</strong>
          </div>
        </ng-container>
      </div>
      <ng-container [formGroup]="control" *ngFor="let control of controls">
        <div data-row-span="8">
          <div data-field-span="4">
            <strong [class.error-text]="!control.get('paramName')?.value"
              >{{ control.get('text')?.value }}
            </strong>
          </div>
          <div data-field-span="2" class="readonly">
            <input type="number" class="input-data" readonly formControlName="ramcoValue" min="0" />
          </div>
          <div
            data-field-span="2"
            [ngClass]="{
              invalid: control.get('flightLogValue').errors?.required
            }"
          >
            <input type="number" class="input-data" formControlName="flightLogValue" min="0" />
          </div>
        </div>
      </ng-container>
    </div>
    <div class="copy-buttons">
      <button color="primary" (click)="onCopyRamco()" mat-raised-button>Copy Ramco</button>
      <button color="primary" (click)="onReset()" mat-raised-button>Reset</button>
    </div>
    <div>
      <br />
      <label>Effective Date</label>
      <kendo-dateinput
        [format]="dateTimeFormat"
        [formControl]="form.get('snapshotEffectiveDate')"
      ></kendo-dateinput>
      <mat-error *ngIf="form.get('snapshotEffectiveDate')?.errors?.date">
        {{ form.get('snapshotEffectiveDate')?.errors?.date?.message }}
      </mat-error>
    </div>

    <div>
      <textarea [formControl]="form.get('remarks')" placeholder="Remarks (required)"></textarea>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div class="action-buttons">
      <button color="primary" (click)="onSave()" focus mat-raised-button [disabled]="form.invalid">
        Save
      </button>
      <button (click)="onCancel()" mat-button>Cancel</button>
    </div>
  </mat-card-actions>
</div>
